<ppl-file-upload [filedInfo]="filedInfo" [authId] = "id" [sectionData]="" [entry]="entry" (filesUpdated)="filesUpdated()" [readonly]="readonly"></ppl-file-upload>
